import React, { ReactNode } from "react";
import { Slice } from "gatsby";
import { LocaleSlugMap } from "@utils/i18n";
import LogoWithBrand from "@images/AccuRankerLogo.svg";
import "./layout.css";
import { ModalProvider } from "@ui/Modals/ModalContext";
// import { TranslationSelect } from "./Header/TranslationSelect";

type Props = {
  hideHeader?: boolean;
  hideFooter?: boolean;
  children: ReactNode;
  locale?: string;
  localeSlugMap?: LocaleSlugMap;
};

const Layout = ({
  hideHeader = false,
  hideFooter = false,
  localeSlugMap = { en: null },
  children,
}: Props) => {
  // const numberOfSupportedLanguages = Object.keys(localeSlugMap).length;
  return (
    <ModalProvider>
      <div>
        {/* allowEmpty to fix: Could not find slice "footer" used by page "/404.html" */}
        {hideHeader ? (
          /* Accuranker logo section */
          <div className="mx-4 mt-4 flex items-center xl:mx-auto xl:max-w-screen-xl">
            <img
              className="m-auto h-8 w-auto sm:h-10 md:m-0 md:mr-auto"
              src={LogoWithBrand}
              alt="AccuRanker Logo"
            />
            {/* {numberOfSupportedLanguages > 1 && locale && (
            <TranslationSelect
              locale={locale}
              localeSlugMap={localeSlugMap}
              ariaLabel={"change language"}
              mobile
            />
          )} */}
          </div>
        ) : (
          <Slice alias="header" localeSlugMap={localeSlugMap} allowEmpty />
        )}
        <div className="mx-auto max-w-7xl px-4">
          <main>{children}</main>
        </div>
        {/* allowEmpty to fix: Could not find slice "footer" used by page "/404.html" */}
        {!hideFooter && (
          <Slice alias="footer" localeSlugMap={localeSlugMap} allowEmpty />
        )}
        <Slice alias="errormodal" allowEmpty />
        <Slice alias="signuperrormodal" allowEmpty />
        <Slice alias="signupmodal" allowEmpty />
        <Slice alias="signupcompletemodal" allowEmpty />
        {/* <Slice alias="stickycta" allowEmpty /> */}
      </div>
    </ModalProvider>
  );
};

export default Layout;
